export const MYCOURSES_LOAD_START = "MyCourses_Load_Start";
export const MYCOURSES_LOAD_END = "MyCourses_Load_End";
export const MYCOURSES_COURSE_PLAY_CLICK = "MyCourses_Course_Play_click";
export const MYCOURSES_COURSE_VIEW_INVOICE_CLICK = "MyCourses_Course_View_Invoice_Click";
export const MYCOURSES_COURSE_PURCHASE_CLICK = "MyCourses_Course_Purchase_Click";
export const MYCOURSES_COURSE_WISHLIST_CLICK ="MyCourses_Course_Wishlist_Click"